import { useToast } from '@/composables/useToast'

export default {
  install(app) {
    const toast = useToast()
    
    // Make toast available globally as $toast
    app.config.globalProperties.$toast = {
      success: toast.success,
      error: toast.error,
      warning: toast.warning,
      info: toast.info,
      show: toast.showToast
    }
    
    // Also provide as composable
    app.provide('toast', toast)
  }
}